module.exports = __webpack_public_path__ + "img/ch.83e33339.webp";